import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IScoresPageDataResult {
  fetch: {
    Country: {
      Scores: {
        IFrame: string | null;
      } | null;
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithScoresPageQueryProps = QueryResult<IScoresPageDataResult>;

class ScoresPageQuery extends Query<IScoresPageDataResult, IVariables> {}

const withScoresPageQuery = <P extends WithScoresPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, WithScoresPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <ScoresPageQuery
      query={queries.GET_SCORES_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </ScoresPageQuery>
  );
};

export default withScoresPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withScoresPageQuery.tsx